import { t } from 'i18next';
import MapPin, { MapIconType } from './pin/MapPin';
import {
  getMapPinProps,
  getOperationStatusTranslationKey,
  OperationStatus,
} from 'src/api/wa/store/models/workplace/OperationStatus';

export type MapLegendProps = {
  className?: string;
};

const MapLegend = (props: MapLegendProps) => {
  const LegendItem = ({ children, pin }: { children: React.ReactNode; pin: React.ReactNode }) => (
    <div className="flex items-center gap-x-2">
      <div className="shrink-0 scale-90 sm:scale-100">{pin}</div>
      <div className="text-[11px] leading-tight text-gray-800 sm:text-xs md:text-sm">
        {children}
      </div>
    </div>
  );

  return (
    <div
      className={
        'grid grid-cols-2 min-[975px]:grid-cols-2 min-[1100px]:grid-cols-3 xl:grid-cols-4 ' +
        (props.className ?? '')
      }
    >
      {[
        OperationStatus.Entrapment,
        OperationStatus.FollowUpRequired,
        OperationStatus.Suspended,
        OperationStatus.TempRecovery,
        OperationStatus.ConfirmationRequired,
        OperationStatus.PhysicalDamage,
        OperationStatus.SiteInaccessible,
        OperationStatus.RecoveryCompleted,
        OperationStatus.Unknown,
        OperationStatus.PowerOutage,
      ].map((status) => (
        <LegendItem key={status} pin={<MapPin {...getMapPinProps(status)} />}>
          {t(getOperationStatusTranslationKey(status))}
        </LegendItem>
      ))}

      <LegendItem pin={<MapPin iconType={MapIconType.hbs} />}>
        {t('wards.sites.map.icons.1')}
      </LegendItem>

      <LegendItem pin={<MapPin iconType={MapIconType.elecare} />}>
        {t('wards.sites.map.icons.2')}
      </LegendItem>

      <LegendItem
        pin={
          <MapPin
            fillColor="text-white"
            lineColor="text-black"
            dotColor="bg-transparent border border-black"
          />
        }
      >
        {t('wards.sites.map.icons.3')}
      </LegendItem>

      <LegendItem pin={<MapPin fillColor="text-white" />}>
        {t('wards.sites.map.reserved')}
      </LegendItem>

      <LegendItem pin={<MapPin iconType={MapIconType.currentUserMatch} />}>
        {t('wards.sites.map.userLocation')}
      </LegendItem>

      <LegendItem
        pin={<MapPin iconType={MapIconType.workerNoMatch} displayNumber={0} hideNumber={true} />}
      >
        {t('wards.sites.map.workerLocation')}
      </LegendItem>

      <LegendItem pin={<MapPin iconType={MapIconType.office} displayNumber={0} />}>
        {t('wards.common.salesOffice')}
      </LegendItem>
    </div>
  );
};

export default MapLegend;
